import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


const configFormData = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };



export async function getAllValves() {
    const res = API.get(`/valves/`, configJson);
    return res;
}

export async function getValveInfo(valve_id) {
    const res = API.get(`/valves/${valve_id}`, configJson);
    return res;
}


export async function createValve(data) {
    const res = API.post(`/valves/`, data, configFormData);
    return res;
}


export async function updateValve(valve_id, data) {
    const res = API.put(`/valves/${valve_id}/`, data, configJson);
    return (await res).data;
}


export async function deleteValve(valve_id) {
    const res = API.delete(`/valves/${valve_id}/`, configJson);
    return res;
}

export async function getValvesByExploitation(exploitation_id) {
    const res = API.get(`/valves/exploitation/${exploitation_id}`, configJson);
    return (await res).data;
}



export async function getValveFilsUrls(valve_id) {
    const res = API.get(`/files/valve/${valve_id}`, configJson);
    return (await res).data;
}



export async function uploadValveFiles(valve_id, data) {
    const res = API.put(`/files/valve/${valve_id}`, data, configFormData);
    return (await res).data;
}

export async function deleteValveFile(valve_id, file_path) {
    const res = API.delete(`/files/valve/${valve_id}/${file_path}`, configJson);
    return (await res).data;
}

